import * as types from './mutation-types'

const mutations = {
  // 用户信息
  [types.SAVA_USER_INFO] (state, v) {
    state.userInfo = v
  },
  [types.SAVA_SERVICE_INFO] (state, v) {
    state.serviceInfo = v
  },
  [types.FREE_RIGHT] (state, v) {
    state.freeRight = v
  }
}

export default mutations
